import React from 'react';
import { useTranslation } from 'react-i18next';
import LegalLayout from '@/components/LegalLayout';

const SECTIONS = [
  ['h_provider', 'p_provider'],
  ['h_service', 'p_service'],
  ['h_eligibility', 'p_eligibility'],
  ['h_risks', 'p_risks'],
  ['h_ip', 'p_ip'],
  ['h_liability', 'p_liability'],
  ['h_law', 'p_law'],
  ['h_changes', 'p_changes'],
];

export default function Terms({ lang }) {
  const { t } = useTranslation();
  return (
    <LegalLayout lang={lang} tKey="terms">
      {SECTIONS.map(([h, p]) => (
        <section key={h} className="aq-legal__section">
          <h2>{t(`terms.${h}`)}</h2>
          <p>{t(`terms.${p}`)}</p>
        </section>
      ))}
    </LegalLayout>
  );
}
